export default __webpack_public_path__ + "static/media/Logo.8fdbec4a.svg";